// This file generate automatically when we build app, default id=4Y29W94EA32NG
export const merchantConfig = {
  id: 'MLMKJN4HCR85D',
};
